import React, { useMemo } from 'react';
import { REPORT_TYPES, importRemote, report, getRemoteRuntime } from '@adsk/exo-skeleton-api';
import { EXO_SKELETON_SCOPE_NAME, RETRY_IMPORT_REMOTE } from '../helpers/consts';
import { useRemotes } from '../providers/RemotesProvider';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export function useCreateLazyRemoteComponent(_ref) {
  let {
    moduleName,
    scope,
    version
  } = _ref;
  const {
    moniker,
    override
  } = getRemoteRuntime(scope) || {};
  const {
    isLoading
  } = useRemotes() || {
    isLoading: false
  };
  return useMemo(() => /*#__PURE__*/React.lazy(() => isLoading ? new Promise(() => void 0) : importRemote({
    scope,
    module: moduleName,
    version,
    onRetry(_ref2) {
      let {
        error,
        retryName,
        tryAttempt
      } = _ref2;
      report({
        type: REPORT_TYPES.error,
        scope: EXO_SKELETON_SCOPE_NAME,
        value: RETRY_IMPORT_REMOTE,
        context: {
          moniker,
          override,
          retryName,
          tryAttempt,
          module,
          scope,
          error
        }
      });
    }
  })), [moduleName, scope, moniker, override, isLoading, version]);
}
//# sourceMappingURL=useCreateLazyRemoteComponent.js.map